<script lang="ts">
  import type { UserNotification } from "$types";
  import { utc_time_from_now } from "$lib/dates";
  export let notification: UserNotification;
  export let hover: boolean = false;
</script>

<div class="text" class:hover>
  <div class="title">
    {#if notification.title}
      {notification.title}
    {:else}
      New video has been posted
    {/if}
  </div>
  {#if notification.date_created}
    <div class="date">
      {utc_time_from_now(notification.date_created)}
    </div>
  {/if}
</div>

<style>
.text {
  padding: 0.5rem;
  display: flex;
  flex-flow: column;
  gap: 0.25rem;
  color: var(--title);
  flex: 1;
}
.text .title {
  font-size: 0.8rem;
  font-weight: bold;
  color: var(--title);
}
.text .date {
  font-size: 0.65rem;
  color: var(--offDark);
}
</style>
